import React from 'react';

const About = () => {
  return (
    <div className="about">
      <div className="container">
        <h1>About Travel Mhor</h1>
        <p className="about-tagline">Wherever you're coming from, you'll find a warm welcome here — on the road and along the way.</p>

        <section className="about-intro">
          <p>
            Private trips, family adventures and seamless transfers. Tailored for comfort, style, and your perfect journey.
          </p>
          <p className="mt-md">
            I pride myself on delivering safe, comfortable, and memorable travel experiences.
          </p>
          <p>
            Travel Mhor is built on one simple idea:
          </p>
          <p>
            Scotland is best experienced when it's made personal.
          </p>
          <p>
            Whether booked directly or through trusted partners, every journey is delivered with care, comfort, and a calm, unhurried approach.
          </p>
        </section>

        <section className="about-mission">

          <h2>The Travel Mhor Approach</h2>
          <p>
            No rigid itineraries. No conveyor-belt touring.
          </p>
          <p>
            Each journey is thoughtfully delivered, with a focus on safety, comfort, and time well spent on the road.
          </p>

          <h3>Why Travel Mhor?</h3>
          <p>
            Because every journey should feel considered, not packaged.
          </p>
          <p>
            Unrushed. Personal. Thoughtful.
          </p>
          <p>
            Scotland, made personal.
          </p>
          <p>
            Let's go for a drive.
          </p>
        </section>

        <section className="about-values">
          <h2>What I Stand For</h2>
          <div className="values-grid">
            <div className="value">
              <h3>Safety First</h3>
              <p>Driven with care and professionalism.</p>
            </div>
            <div className="value">
              <h3>Personal, Professional Service</h3>
              <p>The same attentive service for partners and private clients alike.</p>
            </div>
            <div className="value">
              <h3>Comfort Without Compromise</h3>
              <p>A smooth drive and an unhurried pace.</p>
            </div>
            <div className="value">
              <h3>Local Knowledge, Honestly Shared</h3>
              <p>Scotland as it is — its places, its stories, its quieter corners.</p>
            </div>
          </div>
        </section>

        <section className="about-services">
          <h2>Our Services</h2>
          <p className="services-description">
            We offer a comprehensive range of tour and travel services tailored to your needs:
          </p>
          <ul className="list-checkmark">
            <li>
              <strong>Family-friendly multi-day tours</strong> of Scotland exploring stunning landscapes and historic sites
            </li>
            <li>
              <strong>Day trips</strong> tailored to your interests and schedule
            </li>
            <li>
              <strong>Airport transfers</strong> with professional, punctual service
            </li>
            <li>
              <strong>Corporate transfers</strong> for business groups and events
            </li>
            <li>
              <strong>Custom tour packages</strong> designed to match your specific preferences
            </li>
            <li>
              <strong>Professional driving services</strong> on behalf of tour operators or individual clients
            </li>
          </ul>
          <p className="services-closing">
            Need a larger vehicle? I am happy to provide company recommendations and arrange suitable transport for your group.
          </p>
        </section>

        <section className="about-team">
          <h2>Why Choose Travel Mhor?</h2>
          <ul>
            <li>Licensed and experienced professional driver</li>
            <li>Luxury 7-seater Mercedes V-Class vehicles</li>
            <li>Knowledgeable local expertise</li>
            <li>Flexible scheduling and custom tour options</li>
            <li>Competitive pricing with no hidden fees</li>
          </ul>
        </section>
      </div>
    </div>
  );
};

export default About;